import { Variants } from 'framer-motion';

// Default animation settings
export const defaultTransition = {
  duration: 0.7,
  ease: [0.25, 0.1, 0.25, 1.0] as [number, number, number, number],
};

export const quickTransition = {
  duration: 0.2,
  ease: "easeOut" as const,
};

// Slide animations (replacing CSS slide animations)
export const slideInFromLeft: Variants = {
  hidden: { opacity: 0, x: -30 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: defaultTransition,
  },
};

export const slideInFromRight: Variants = {
  hidden: { opacity: 0, x: 30 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: defaultTransition,
  },
};

export const slideInFromBottom: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: defaultTransition,
  },
};

export const slideInFromTop: Variants = {
  hidden: { opacity: 0, y: -30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: defaultTransition,
  },
};

// Fade animations
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: defaultTransition,
  },
};

// Scale animations (replacing hover-scale)
export const scaleOnHover: Variants = {
  rest: { scale: 1 },
  hover: { 
    scale: 1.02,
    transition: quickTransition,
  },
};

// Lift animations (replacing hover-lift)
export const liftOnHover: Variants = {
  rest: { 
    y: 0,
    boxShadow: "0 0 0 rgba(0, 0, 0, 0)",
  },
  hover: { 
    y: -2,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    transition: quickTransition,
  },
};

// Container variants for staggered animations
export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1,
    },
  },
};

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: defaultTransition,
  },
};

// Viewport-based animation options
export const viewportOptions = {
  once: true,
  margin: "-50px",
};